import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useTheme } from "@emotion/react";
import {
  Checkbox,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

const RenewEstimateModal = ({
  open,
  handleClose,
  onRenewEstimate,
  loading,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [commentText, setCommentText] = useState("");

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullScreen={isSmallScreen}
      fullWidth={true}
    >
      <DialogContent>
        <Box sx={{}}>
          <Box
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{ textAlign: "start", width: "100%", fontWeight: "bold" }}
            >
              Request A New Quote
            </Typography>
            <TextField
              fullWidth
              variant="filled"
              multiline
              rows={5}
              label="Comment (Optional)"
              value={commentText}
              onChange={(e) => setCommentText(e.target.value)}
            />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-end",
          justifyContent: "flex-end",
        }}
      >
        <LoadingButton
          loading={loading}
          disabled={loading}
          onClick={handleClose}
        >
          Back
        </LoadingButton>
        <LoadingButton
          loading={loading}
          variant="contained"
          disabled={loading}
          onClick={async () => {
            await onRenewEstimate(commentText);
            handleClose();
          }}
        >
          Submit
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
export default RenewEstimateModal;
